import Skeleton from '@/app/components/feedback/Skeleton';
/* eslint-disable @typescript-eslint/no-redundant-type-constituents */
import React from 'react';
import { KTSVG as KtSvg } from '../../../../_metronic/helpers';
import MetronicCard from '@/app/components/layout/MetronicCard';

export type SummaryCardProps = {
  title: string;
  value: string;
  helper: string;
  icon: string;
  theme: 'primary' | 'success' | 'danger' | 'dark' | string;
  helperColor?: 'success' | 'danger' | 'primary' | 'warning' | 'info' | 'muted' | string;
  loading?: boolean;
  initialLoading?: boolean;
};

const SummaryCard: React.FC<SummaryCardProps> = ({
  title,
  value,
  helper,
  icon,
  theme,
  helperColor = 'success',
  loading = false,
  initialLoading = false,
}) => {
  const isBusy = initialLoading || loading;
  return (
    <MetronicCard className="card-xxl-stretch shadow-sm h-100" loading={loading}>
      <div aria-busy={isBusy} className="card-body d-flex align-items-center p-6">
        {initialLoading ? <output className="visually-hidden">Carregando resumo...</output> : null}
        <div className="symbol symbol-50px me-4 flex-shrink-0">
          <div className={`symbol-label bg-light-${theme}`}>
            <KtSvg className={`svg-icon-2x text-${theme}`} path={icon} />
          </div>
        </div>
        <div className="d-flex flex-column">
          <span className="text-gray-500 fw-semibold fs-7">{title}</span>
          <span className="fs-2hx fw-bold text-gray-900 lh-1">
            {initialLoading ? <Skeleton height={32} width={110} /> : value}
          </span>
          <span className={`fw-semibold fs-7 text-${helperColor}`}>
            {initialLoading ? <Skeleton height={14} width={130} /> : helper}
          </span>
        </div>
      </div>
    </MetronicCard>
  );
};

export default SummaryCard;
